import { createFileRoute } from '@tanstack/react-router';

import { createMigrationRouteGuard } from '@/utils/route-guards/migration-guard';

export const Route = createFileRoute('/$org/$agent/map')({
  beforeLoad: (ctx) => {
    createMigrationRouteGuard('map')(ctx);
  },
});
